import { ChatLayout } from './chat-layout.interface'

export const chatLayouts: ChatLayout[] = [
  {
    name: '100%',
    columns: [
      {
        isPrimary: true,
        width: 12
      }
    ]
  },
  {
    name: '66%:33%',
    columns: [
      {
        isPrimary: true,
        width: 8
      },
      {
        isPrimary: false,
        width: 4
      }
    ]
  },
  {
    name: '50%:50%',
    columns: [
      {
        isPrimary: true,
        width: 6
      },
      {
        isPrimary: false,
        width: 6
      }
    ]
  },
  {
    name: '33%:33%:33%',
    columns: [
      {
        isPrimary: true,
        width: 4
      },
      {
        isPrimary: false,
        width: 4
      },
      {
        isPrimary: false,
        width: 4
      }
    ]
  },
  {
    name: '25%:25%:25%:25%',
    columns: [
      {
        isPrimary: true,
        width: 3
      },
      {
        isPrimary: false,
        width: 3
      },
      {
        isPrimary: false,
        width: 3
      },
      {
        isPrimary: false,
        width: 3
      }
    ]
  }
]
